import RequestManager from "src/requests/RequestManager";
import { Player, Team } from "../interfaces";
import { isMockDataActive, roster, team as mockTeam } from "../mockData";
import { RosterTask, TeamTask } from "../tasks";
import { parsePlayer, parseTeam } from "../utils";

// Se usa en VCardDirectorTécnico
export default async function getCoach(teamId: string, coachId: string): Promise<{
    coach: Player,
    relatedPlayers: Player[],
    team: Team
}> {
    const rosterTask = new RosterTask(teamId);
    const teamTask = new TeamTask(teamId);
    let rosterResult;
    let team;
    if(isMockDataActive) {
        rosterResult = roster;
        team = mockTeam;
    } else {
        rosterResult = await RequestManager.addRequest(rosterTask);
        const teamResult = await RequestManager.addRequest(teamTask);
        team = parseTeam(teamResult.team || {})

    }
    const players = rosterResult.players || [];
    const coaches = (rosterResult.coaches) || []
    const coach = parsePlayer(coaches.length > 0 ? coaches[0] : {});
    const relatedPlayers = players.map((ply: any) => parsePlayer(ply));

    return {
        coach,
        relatedPlayers,
        team
    }
    
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getCoach.ts